<template>
    <div :class="{ 'modal': true, 'active': showModal }">
        <div class="modal-content">

            <div class="modal-content-header">
            	<h3>
                	{{ $t('label.addAppointment') }}
            	</h3>
                <span class="modal-content-header-close" @click.prevent="close(false)">
					<i aria-hidden="true" class="icon icon-close-large"></i>
				</span>
            </div>

            <div class="modal-content-body form">
                <div class="row">
                    <div class="col-lg-12">
                        {{ appointment.date | formatDate }} {{ appointment.start | formatTime }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <customer-chooser-widget ref="customerChooser" v-model="customer"></customer-chooser-widget>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <chooser-widget ref="servicesChooser" url="/v1/services/all" :label="$t('label.services')" v-model="services">
                        	<router-link to="/organization/settings/services" class="link">+ {{ $t('label.addService') }}</router-link>
                        </chooser-widget>
                    </div>
                </div>
				<div class="row modal-content-body-highlight middle">
                	<div class="col-lg-8 col-xs-8">
                        <div class="row">
                            <div class="modal-content-body-highlight-total">
                                <span class="text-uppercase">{{ $t('label.total') }}</span>
                                <input-widget validate="required" v-model="price" :type="'number'"></input-widget>
                                <span>{{ currency.toUpperCase() }}</span>
                            </div>
                        </div>
                	</div>
                	<div class="col-lg-4 col-xs-4 text-right">
                		<span aria-hidden="true" class="icon icon-timer"></span> {{ duration.hours }} {{ $t('label.h') }} {{ duration.minutes }} {{ $t('label.min') }}
                	</div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="button-wrapper-right margin-bottom-20">
                            <input type="submit" :value="$t('button.save')"
                                   :class="{'button-full': true, 'loading': loading}" @click.prevent="validate"/>
                            <span class="button-hollow" @click.prevent="close(false)">{{ $t('button.cancel') }}</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
  import auth from '@/auth'
  import InputWidget from '@/components/widgets/InputWidget'
  import ChooserWidget from '@/components/widgets/ChooserWidget'
  import CustomerChooserWidget from '@/components/widgets/CustomerChooserWidget'

  const CreateAppointmentModal = {
    name: 'CreateAppointmentModal',
    components: {InputWidget, ChooserWidget, CustomerChooserWidget},
    data () {
      return {
        showModal: false,
        loading: false,
        appointment: {},
        customer: null,
        services: [],
        price: 0,
        currency: auth.getOrganization().currency.toUpperCase()
      }
    },
    watch: {
      services () {
        let total = 0
        for (let i in this.services) {
          total = total + parseFloat(this.services[i].price)
        }
        this.price = total
      }
    },
    computed: {
      duration () {
        let d = {
          hours: 0,
          minutes: 0
        }

        if (!this.services.length) {
          return d
        }
        let servicesDuration = 0
        for (let i in this.services) {
          let pause = this.services[i].pause === null ? 0 : this.services[i].pause
          servicesDuration += parseFloat(this.services[i].duration) + parseFloat(pause)
        }

        d.hours = parseInt(servicesDuration)
        d.minutes = ((servicesDuration - d.hours) % 60) * 60

        return d
      }
    },
    methods: {
      show (data) {
        Object.assign(this.appointment, data)
        this.showModal = true
      },
      validate () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.save()
          }
        })
      },
      save () {
        this.loading = true
        Object.assign(this.appointment, { price: this.price, services: this.services, customer: this.customer })
        this.$api.post('/v1/appointments', this.appointment).then(response => {
          this.$emit('created', response.data.data)
          this.close(true)
          this.loading = false
        }).catch(error => {
          this.loading = false
          console.error(error)
          this.$events.fire('message-open', {
            type: 'error',
            message: this.$t('message.somethingWentWrong')
          })
        })
      },
      close (updated) {
        this.appointment = {}
        this.customer = null
        this.services = []
        this.$refs.servicesChooser.clear()
        this.$refs.customerChooser.removeSelection()
        this.price = 0
        this.showModal = false
        this.$emit('closed', {
          show: this.showModal,
          updated: updated
        })
      }
    }
  }

  export default CreateAppointmentModal
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/Table/CreateAppointmentModal.vue